import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSingleMedBill } from "../../../api/Payment";
import FullScreeeSpinner from "../../../components/common/loading/FullScreee";
import MedicinePaymentDetailsLayout from "../../../components/ui/Payments/pages/medcine-bill-details/medicne-bill-details.jsx";

const MedicineBillDetails = () => {
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const [prescription, setPrescription] = useState({});
  const [next_appointment, setNext_appointment] = useState({});
  // Get the current location
  const location = useLocation();
  // Parse the query parameters
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const navigate = useNavigate();
  const redirect = () => {
    navigate(`/payments?activeTab=medicine`);
  };
  const getInvoiceDetails = () => {
    setLoading(true);
    getSingleMedBill(id)
      .then((response) => {
        console.log({ response });
        setDetails(response?.data?.data);
        setPrescription(response?.data?.prescription);
        setNext_appointment(response?.data?.next_appointment);
      })
      .catch((error) => {
        // showErrorToast(error, "error");
        redirect();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getInvoiceDetails();
  }, [id]);

  if (loading) {
    return (
      <div>
        <FullScreeeSpinner />
      </div>
    );
  }
  return (
    <div>
      <MedicinePaymentDetailsLayout
        details={details}
        prescription={prescription}
        getInvoiceDetails={getInvoiceDetails}
        next_appointment={next_appointment}
      />
    </div>
  );
};

export default MedicineBillDetails;
